export default "/images/ae23377b08153749cf3b6bee8fe228c3.avif";